import React, { useCallback } from 'react'
import { getFocusableChildren } from 'helpers/getters'

import s from './SkipContent.scss'


type SkipContentProps = {
  contentId: string
}

const SkipContent: React.FC<SkipContentProps> = ({ contentId }) => {
  const handleClick = useCallback((event) => {
    event.preventDefault()

    const mainContentEl = document.getElementById(contentId)
    const focusableElements = getFocusableChildren(mainContentEl)
    const firstFocusableEl = focusableElements[0]

    if (firstFocusableEl) {
      firstFocusableEl.focus()
    }
  }, [ contentId ])

  return (
    <a className={s.skipContent} href={`#${contentId}`} onClick={handleClick}>
      Перейти к контенту
    </a>
  )
}


export default SkipContent
